// extracted by mini-css-extract-plugin
module.exports = {"context":"CreateEditInvoiceRequestForm_context__ATQ52","padding":"CreateEditInvoiceRequestForm_padding__4GDll"};